import React from "react";
import { FaLinkedin, FaTwitter } from "react-icons/fa";

/* ─── team data ──────────────────────────────────────────────────────────── */
const team = [
  {
    name: "Erick Kanjal",
    role: "Founder & CEO",
    bio: "Leads strategy and vision for Electromob's expansion across Nigeria.",
    initials: "EK",
    linkedin: "https://linkedin.com/in/erick-kanjal",
    twitter: "https://x.com/erickkanjal",
  },
  {
    name: "Amaka Obi",
    role: "Head of Operations",
    bio: "Oversees fleet logistics, dealership partnerships, and service quality.",
    initials: "AO",
    linkedin: "https://linkedin.com/company/electromob",
    twitter: "https://x.com/electromob",
  },
  {
    name: "Tunde Bakare",
    role: "Lead Engineer",
    bio: "Manages vehicle technology, charging infrastructure, and diagnostics.",
    initials: "TB",
    linkedin: "https://linkedin.com/company/electromob",
    twitter: "https://x.com/electromob",
  },
  {
    name: "Chiamaka Eze",
    role: "Marketing Lead",
    bio: "Drives brand awareness and customer engagement campaigns.",
    initials: "CE",
    linkedin: "https://linkedin.com/company/electromob",
    twitter: "https://x.com/electromob",
  },
  {
    name: "David Okon",
    role: "Sales Manager",
    bio: "Builds customer relationships and manages the sales pipeline.",
    initials: "DO",
    linkedin: "https://linkedin.com/company/electromob",
    twitter: "https://x.com/electromob",
  },
  {
    name: "Funmi Adeyemi",
    role: "Finance Lead",
    bio: "Manages budgeting, pricing strategy, and financial planning.",
    initials: "FA",
    linkedin: "https://linkedin.com/company/electromob",
    twitter: "https://x.com/electromob",
  },
];

/* ═══════════════════════════════════════════════════════════════════════════ */
const ProfilesP = () => {
  return (
    <div className="bg-white min-h-screen">

      {/* hero band */}
      <div
        className="bg-gradient-to-br from-[#102a05] to-[#4a8f0f] text-white
                   pt-36 pb-20 px-6 md:px-10 lg:px-16"
      >
        <span className="text-white/70 font-semibold uppercase tracking-widest text-xs">
          Our Team
        </span>
        <h1 className="text-4xl md:text-5xl font-bold mt-3">
          Meet the team
        </h1>
        <p className="text-white/80 mt-4 max-w-xl text-sm leading-relaxed">
          The people behind Electromob, building a cleaner and smarter way
          to move across Nigeria.
        </p>
      </div>

      {/* grid */}
      <div className="px-6 md:px-10 lg:px-16 py-16 max-w-7xl mx-auto">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((person) => (
            <ProfileCard key={person.name} {...person} />
          ))}
        </div>
      </div>
    </div>
  );
};

/* ─── profile card ───────────────────────────────────────────────────────── */
const ProfileCard = ({ name, role, bio, initials, linkedin, twitter }) => (
  <div
    className="group bg-gray-50 hover:bg-white rounded-2xl border border-gray-100
               hover:border-[#6ab615]/30 hover:shadow-lg transition-all duration-200
               p-6 flex flex-col items-center text-center"
  >
    {/* avatar */}
    <div
      className="w-20 h-20 rounded-full bg-[#6ab615]/10 text-[#4a8f0f]
                 flex items-center justify-center text-xl font-bold mb-4
                 group-hover:bg-[#6ab615] group-hover:text-white
                 transition-colors duration-200"
    >
      {initials}
    </div>

    <h3 className="font-bold text-gray-900">{name}</h3>
    <p className="text-sm text-[#4a8f0f] font-medium mt-0.5">{role}</p>
    <p className="text-sm text-gray-500 mt-3 leading-relaxed">{bio}</p>

    {/* social links ── real hrefs, no more "#" */}
    <div className="flex gap-3 mt-5">
      <a
        href={linkedin}
        target="_blank"
        rel="noreferrer"
        aria-label={`${name} on LinkedIn`}
        className="text-gray-400 hover:text-[#4a8f0f] transition-colors duration-200"
      >
        <FaLinkedin className="text-lg" />
      </a>
      <a
        href={twitter}
        target="_blank"
        rel="noreferrer"
        aria-label={`${name} on Twitter`}
        className="text-gray-400 hover:text-[#4a8f0f] transition-colors duration-200"
      >
        <FaTwitter className="text-lg" />
      </a>
    </div>
  </div>
);

export default ProfilesP;